'use client';

import { useTranslations } from 'next-intl';
import TechSectionMobile from './tech-section-mobile';
import TechSectionDesktop from './tech-section-desktop';

export interface FeatureCard {
  title: string;
  description: string;
  icon: string;
  hoverIcon: string;
}

export default function TechSection() {
  const t = useTranslations('home.tech.features');
  
  const featureCards: FeatureCard[] = [
    {
      title: t('ultraDeepLiquidity.title'),
      description: t('ultraDeepLiquidity.description'),
      icon: "/icons/tech-1.webp",
      hoverIcon: "/icons/tech-1-hover.svg",
    },
    {
      title: t('lightningFastExecution.title'),
      description: t('lightningFastExecution.description'),
      icon: "/icons/tech-2.webp",
      hoverIcon: "/icons/tech-2-hover.svg",
    },
    {
      title: t('provenSecurity.title'),
      description: t('provenSecurity.description'),
      icon: "/icons/tech-3.webp",
      hoverIcon: "/icons/tech-3-hover.svg",
    },
    {
      title: t('unifiedExperience.title'),
      description: t('unifiedExperience.description'),
      icon: "/icons/tech-4.webp",
      hoverIcon: "/icons/tech-4-hover.svg",
    },
  ];
  // Render appropriate component based on screen size
  // Using CSS classes for initial render, then dynamic import handles the rest
  return (
    <>
      {/* Desktop - hidden on mobile */}
      <div className="hidden md:block">
        <TechSectionDesktop featureCards={featureCards} />
      </div>
      
      {/* Mobile - hidden on desktop */}
      <div className="md:hidden">
        <TechSectionMobile featureCards={featureCards} />
      </div>
    </>
  );
}

